import type { LoaderFunctionArgs, MetaFunction } from "@remix-run/cloudflare";
import { redirect } from "@remix-run/cloudflare";
import { useLoaderData } from "@remix-run/react";
import Container from "~/components/layout/Container";
import { buildMeta, descriptionFromHtml } from "~/lib/seo";
import { slugify } from "~/lib/slugify";
import { references } from "../_index";
import References from "../features/References";
import Slogans from "../features/Slogans";
import { HizmetListesi } from "./_index";

export const loader = async ({ params }: LoaderFunctionArgs) => {
  const service = HizmetListesi.find((service) => service.id === Number(params.id));
  if (!service) {
    throw new Response("Not Found", { status: 404 });
  }
  // Canonical slug kontrolü: yanlış slug ile gelindiyse doğru URL'ye 301 yönlendir.
  const canonicalSlug = slugify(service.title);
  if (params.slug !== canonicalSlug) {
    throw redirect(`/hizmetlerimiz/${canonicalSlug}/${service.id}`, 301);
  }
  return {
    service,
    services: HizmetListesi,
    references: references
  }
}
export const meta: MetaFunction<typeof loader> = ({ data }) => {
  const service = data?.service;
  if (!service) {
    return buildMeta({
      title: "Hizmet Bulunamadı | Al-De Mühendislik",
      description: "Aradığınız hizmet bulunamadı.",
      path: "/hizmetlerimiz",
    });
  }
  return buildMeta({
    title: `${service.title} | Manisa, İzmir, Turgutlu | Al-De Mühendislik`,
    description: descriptionFromHtml(service.description),
    path: `/hizmetlerimiz/${slugify(service.title)}/${service.id}`,
    image: service.image,
    type: "article",
  })
}
export default function Page() {
  const { service, services, references } = useLoaderData<typeof loader>();
  return (
    <div className="mt-48">
      <div className="">
        <Container className="flex-wrap">
          <h1 className="text-3xl w-full justify-center font-black font-raleway my-4 text-center text-[32px]">HİZMETLERİMİZ </h1>
          <p className="text-center mb-10 text-[24px] font-lato text-[#444444] mb-20">
            Al-De Mühendislik olarak, uzman kadromuz ve yılların deneyimiyle, müşterilerimizin ihtiyaçlarına yönelik en uygun ve yenilikçi çözümleri sunuyoruz.
          </p>
          <div className="flex flex-wrap mb-10 items-start">
            <img src={service.image} alt={service.title} width={400} height={300} loading="lazy" className="w-full md:w-1/3 group-hover:shadow-lg object-cover box-border mb-20" />
            <div className="w-full box-border flex flex-wrap md:!w-2/3 md:pl-12">
              <h3 className="flex w-full text-xl font-black font-raleway text-lg text-[#16437c] mb-4">{service.title}</h3>
              <div key={service.title} className="w-full text-[14px] font-lato text-[#333333]">
                <span dangerouslySetInnerHTML={{ __html: service.description }} className="block mt-2 mb-8 text-base [&_h3]:text-[#16437c] [&_h3]:text-[16px] [&_h3]:font-bold [&_h3]:mt-4 [&_h3]:font-raleway [&_li]:pb-4 [&_p]:pb-4 [&_li_strong]:font-semibold [&_strong]:text-[#16437c] [&_strong]:text-[16px] [&_strong]:font-bold [&_strong]:mt-4 [&_strong]:font-raleway [&_strong]:leading-24" />
              </div>
            </div>
          </div>
        </Container>
      </div>
      <Slogans />
      {/* <ServicesComponent services={services} /> */}
      <References references={references} />
    </div>
  )
}
